import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';

import MLIcon from '../../MLIcon';

import s from '../MLDialog.module.css';

const FooterErrors = ({ errors }) => {
  if (!errors || !errors.length) return null;

  return (
    <>
      <MLIcon type="warning" className={s.warningIcon} />
      <div className={s.errorMessageContainer}>
        {errors.map(({ message, hasAsterisk = true, errorType }, i) => (
          <div
            className={s.errorMessage}
            key={i}
            data-test-id={errorType || `error_message_${i}`}
          >
            {hasAsterisk ? '*' : ''}
            {message}
          </div>
        ))}
      </div>
    </>
  );
};

const ActionsList = ({ actions }) => {
  return map(actions, (action, i) => {
    const actionClassName = action.props.actionClassName || '';
    return (
      <div key={i} className={actionClassName}>
        {action}
      </div>
    );
  });
};

const MLDialogActions = ({ actions, footerErrors, actionClasses }) => {
  if (!actions) return null;

  return (
    <div className={actionClasses}>
      <div className={s.errorContainer}>
        <FooterErrors errors={footerErrors} />
      </div>
      <div className={s.actionContainer}>
        <ActionsList actions={actions} />
      </div>
    </div>
  );
};

MLDialogActions.propTypes = {
  actions: PropTypes.array,
  footerErrors: PropTypes.array,
  actionClasses: PropTypes.string,
};

export default MLDialogActions;
